<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <GradeClassStudentSelect
          :gradeCol="{ cols: 12, md: 6 }"
          :classCol="{ cols: 12, md: 6 }"
          disableStudentSelect
          @changed="gradeClassChange"
        />
      </v-col>
      <v-col cols="12" md="4">
        <AutocompleteSubject
          label="Môn học"
          v-model="subjectData"
          return-object
          placeholder="Môn học"
          outlined
          dense
          hide-details
          :filter="subjectFilter"
          :disabled="!selectedClass"
        />
      </v-col>

      <v-col cols="12" class="d-flex justify-space-between align-center">
        <RadioSemester :schoolYear="currentSchoolYear" @change="onRadioSemesterChange" />
        <v-btn
          :disabled="isFilterButtonDisabled"
          :class="{ 'mt-4': $vuetify.breakpoint.smAndDown }"
          color="primary"
          @click="onFilterChanged"
        >
          Xem điểm
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import GradeClassStudentSelect from '../../components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import RadioSemester from '@/components/basic/input/RadioSemester'

export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteSubject,
    RadioSemester
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    subjectData: null,
    semesterData: null
  }),
  computed: {
    ...mapState('app', ['currentSchoolYear']),
    subjectFilter() {
      return {
        grade: get(this.selectedGrade, 'id', '') || get(this.selectedClass, 'grade.id', ''),
        division: get(this.selectedClass, 'division.id')
      }
    },
    isFilterButtonDisabled() {
      return !this.selectedGrade || !this.selectedClass || !this.subjectData || !this.semesterData
    }
  },
  methods: {
    gradeClassChange(data) {
      if (get(this.subject, 'subjectGroup.grade.id') !== get(this.data, 'grade.id')) {
        this.subject = null
      }
      this.selectedGrade = get(data.grade, 'id', '') ? { ...data.grade } : null
      if (
        this.subjectData &&
        get(data.class, 'id', '') &&
        (get(data.class, 'grade.id', '') !== this.subjectData.grade.id ||
          get(data.class, 'division.id') !== get(this.subjectData, 'division.id'))
      ) {
        this.subjectData = null
      }
      this.selectedClass = get(data.class, 'id', '') ? { ...data.class } : null
    },
    onRadioSemesterChange(semester) {
      this.semesterData = semester
    },
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        class: this.selectedClass,
        grade: this.selectedGrade,
        semester: this.semesterData,
        subject: this.subjectData
      })
    }
  }
}
</script>
